import type { DensityChartWindow } from "./DensityChart.lib";
import type { DensityChartBucketUnit } from "./densityBuckets.lib";
import { toBarIndex } from "./densityBuckets.lib";

/** A window fits a unit when it takes at most this share of the bars in view, leaving room around it. */
const FIT_SHARE = 0.7;
const COARSER_UNITS: readonly DensityChartBucketUnit[] = [
    "day",
    "week",
    "month",
];

interface FitParams {
    window: DensityChartWindow;
    unit: DensityChartBucketUnit;
    visibleBars: number;
}

const windowBarCount = ({ window, unit }: Omit<FitParams, "visibleBars">) =>
    toBarIndex({ date: window.end, unit }) +
    1 -
    toBarIndex({ date: window.start, unit });

export function fitsWindow({ window, unit, visibleBars }: FitParams): boolean {
    return windowBarCount({ window, unit }) <= visibleBars;
}

/**
 * The unit the bars show for a window: `unit`, the closest one wanted, if
 * the window takes at most `FIT_SHARE` of the bars in view there, else the
 * next coarser one where it does, else months.
 */
export function fitDensity({
    window,
    unit,
    visibleBars,
}: FitParams): DensityChartBucketUnit {
    return (
        COARSER_UNITS.slice(COARSER_UNITS.indexOf(unit)).find(
            (candidate) =>
                windowBarCount({ window, unit: candidate }) <=
                visibleBars * FIT_SHARE,
        ) ?? "month"
    );
}
